const toText = (value) => String(value ?? '').trim().toLowerCase();

const toBool = (value) => value === true;

export const normalizeHealthStatus = (value) => {
  const text = toText(value);
  if (text === 'ok' || text === 'warn' || text === 'down' || text === 'unknown') return text;
  return 'unknown';
};

export const resolveGenieHealthStatus = (payload) => {
  if (!payload || typeof payload !== 'object') return 'unknown';
  if (toBool(payload.connected) || toBool(payload.reachable) || toBool(payload.available)) return 'ok';
  if (toBool(payload.configured)) return 'warn';
  const statusText = toText(payload.status);
  if (statusText === 'up') return 'ok';
  if (statusText === 'degraded') return 'warn';
  if (statusText === 'down') return 'down';
  return 'down';
};

export const resolveRadiusHealthStatus = (payload) => {
  if (!payload || typeof payload !== 'object') return 'unknown';
  if (toBool(payload.connected) || toBool(payload.server_available)) return 'ok';
  if (toBool(payload.configured)) return 'warn';
  const statusText = toText(payload.status);
  if (statusText === 'up') return 'ok';
  if (statusText === 'degraded') return 'warn';
  if (statusText === 'down') return 'down';
  return 'down';
};

export const toBooleanFromHealthStatus = (value) => normalizeHealthStatus(value) === 'ok';
